import { useContext } from 'react';
import Context from './Context';
export { default as withSms } from './with';
export { default } from './Provider';

export function useSms() {
  return useContext(Context);
}
